import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.logoSection}>
          <img src="/assets/logo.png" alt="Prakash Coffee Works" style={styles.logo} />
          <h1 style={styles.title}>1946 Filter Coffee & Tea</h1>
          <p style={styles.tagline}>Franchise Order System</p>
        </div>

        <div style={styles.buttonGroup}>
          <button
            data-testid="place-order-btn"
            className="btn-primary"
            onClick={() => navigate('/franchise-login')}
            style={styles.button}
          >
            Place New Order
          </button>
          <button
            data-testid="admin-dashboard-btn"
            className="btn-secondary"
            onClick={() => navigate('/admin')}
            style={styles.button}
          >
            Admin Dashboard
          </button>
        </div>

        <div style={styles.infoCard}>
          <h3 style={styles.infoTitle}>Welcome to 1946 Filter Coffee & Tea</h3>
          <p style={styles.infoText}>
            Our franchise ordering system makes it easy to request raw materials.
            Simply fill out the order form and we'll receive your request instantly.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f9f6f1 0%, #e8dcc8 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  content: {
    maxWidth: '600px',
    width: '100%',
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: '48px',
  },
  logo: {
    width: '160px',
    height: '160px',
    objectFit: 'contain',
    margin: '0 auto',
  },
  '@media (max-width: 768px)': {
    logo: {
      width: '120px',
      height: '120px',
    },
  },
  title: {
    fontSize: 'clamp(28px, 6vw, 48px)',
    color: '#6b4423',
    marginTop: '24px',
    marginBottom: '8px',
    fontFamily: "'League Spartan', sans-serif",
    fontWeight: '700',
  },
  tagline: {
    fontSize: 'clamp(16px, 3vw, 20px)',
    color: '#8b5e34',
    fontWeight: '500',
    fontFamily: "'League Spartan', sans-serif",
    letterSpacing: '0.5px',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '32px',
  },
  button: {
    width: '100%',
  },
  infoCard: {
    background: 'white',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
  },
  infoTitle: {
    fontSize: '20px',
    color: '#6b4423',
    marginBottom: '12px',
    fontFamily: "'League Spartan', sans-serif",
    fontWeight: '600',
  },
  infoText: {
    fontSize: '16px',
    color: '#6b5d54',
    lineHeight: '1.6',
  },
};

export default HomePage;